import routes from '@routes';
import { CacheProps, fetchApi } from '../../fetch';

interface PostLikeApiProps extends CacheProps {
  id: string | number;
}

const postLikeApi = async ({ id, ...rest }: PostLikeApiProps) => {
  const res = await fetchApi({
    method: 'POST',
    URL: {
      pathname: routes['api.posts.like'],
      query: {
        id: id,
      },
    },
    withToken: true,
    ...rest,
  });

  return res;
};

export default postLikeApi;
